var PanelElementsCategoryView = require( './category' ),
	PanelElementsCategoriesView;

PanelElementsCategoriesView = Marionette.CompositeView.extend( {
	template: '#tmpl-kitbuilder-panel-categories',

	childView: PanelElementsCategoryView,

	childViewContainer: '#kitbuilder-panel-categories',

	id: 'kitbuilder-panel-elements-categories',

	initialize: function() {
		this.listenTo( kitbuilder.channels.panelElements, 'filter:change', this.onPanelElementsFilterChange );
	},

	onPanelElementsFilterChange: function() {
		kitbuilder.getPanelView().getCurrentPageView().showView( 'elements' );
	}
} );

module.exports = PanelElementsCategoriesView;
